import { ProtectedRoute } from "./ProtectedRoute";
import DashboardPage from "features/Dashboard/pages/DashboardPage.tsx";

export const DashboardRoutes = ProtectedRoute({
	path: "dashboard",
	element: <DashboardPage />
});
